import React from 'react';
import { isEmpty } from 'lodash';
import RupeeSymbol from '../rupeeComponent.js/index.js';
import './style.css';

const OrderTotalBill = (props) => {
    const { selectedOrder } = props;

    const offersListDiscountAmount = (order) => {
        let membershipDiscount = parseFloat(order?.membership_discount) || 0;
        let offers = 0;

        if (order?.cart?.offers && order.cart.offers.length) {
            order.cart.offers.forEach((offer) => {
                if (offer.offer_type !== 'free_delivery') {
                    offers += parseFloat(offer.discount_amount) || 0;
                }
            });
        }

        if (membershipDiscount > 0 && offers > 0) {
            return membershipDiscount + offers;
        } else if (membershipDiscount > 0) {
            return membershipDiscount;
        } else {
            return offers;
        }
    };

    const checkFreeDeliveryOffer = (order) => {
        let offers = '';

        if (order?.membership_delivery_charge_discount && order?.membership_delivery_charge_discount !== '0.00') {
            offers = '[ Membership ]';
        } else if (order?.cart?.offers && order?.cart?.offers?.length) {
            order.cart.offers.map((offer) => {
                if (offer.offer_type === 'free_delivery' && offer.coupon_code) {
                    offers += offer.coupon_code + ', ';
                }
                return null;
            });

            if (offers) {
                offers = '[' + offers.substring(0, offers.length - 2) + ']';
            }
        }

        return offers;
    };

    const offersList = (order) => {
        let offers = '';

        // Convert membership_discount to a number
        let membershipDiscount = parseFloat(order?.membership_discount) || 0;

        if (membershipDiscount > 0) {
            offers = '[ Membership ]';
            if (order?.cart?.offers && order?.cart?.offers?.length) {
                order.cart.offers.map((offer) => {
                    if (offer.offer_type !== 'free_delivery' && offer.coupon_code) {
                        offers += ' [ ' + offer.coupon_code + ' ]';
                    }
                });
            }
        } else if (order?.cart?.offers?.length) {
            let offerCodes = order.cart.offers
                .filter((offer) => offer.offer_type !== 'free_delivery' && offer.coupon_code)
                .map((offer) => offer.coupon_code)
                .join(', ');

            if (offerCodes) {
                offers = `[ ${offerCodes} ]`;
            }
        }

        return offers;
    };

    if (isEmpty(selectedOrder)) return null;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <table style={{ width: '100%' }}>
                <tbody>
                    {offersListDiscountAmount(selectedOrder) ? (
                        <tr className='borderColorForTable'>
                            <td className='borderForFirstTd'>
                                <span>Discount {offersList(selectedOrder)}</span>
                            </td>
                            <td className='borderForSecondTd'>
                                <RupeeSymbol size={'12px'} />
                                {parseFloat(offersListDiscountAmount(selectedOrder)).toFixed(2)}
                            </td>
                        </tr>
                    ) : null}

                    {selectedOrder.cart &&
                    !isEmpty(selectedOrder.cart.cashback) &&
                    selectedOrder.cart.cashback.used_cashback ? (
                        <tr className='borderColorForTable'>
                            <td className='borderForFirstTd'>Cashback</td>
                            <td className='borderForSecondTd'>
                                <RupeeSymbol size={'12px'} />
                                {selectedOrder.cart.cashback.used_cashback}
                            </td>
                        </tr>
                    ) : null}

                    <tr className='borderColorForTable'>
                        <td className='borderForFirstTd'>
                            <span>Gross Total</span>
                        </td>
                        <td className='borderForSecondTd'>
                            <RupeeSymbol size={'12px'} />
                            {selectedOrder?.gross_total?.toFixed(2)}
                        </td>
                    </tr>

                    <tr className='borderColorForTable'>
                        <td className='borderForFirstTd'>
                            {(selectedOrder.membership_convenience_charge_discount &&
                                selectedOrder.membership_convenience_charge_discount !== '0.00') ||
                            (selectedOrder.membership_packaging_charge_discount &&
                                selectedOrder.membership_packaging_charge_discount !== '0.00')
                                ? 'Other Charges & Taxes [ Membership ]'
                                : 'Other Charges & Taxes'}
                        </td>
                        <td className='borderForSecondTd'>
                            {!(
                                ['0', '0.00', 0, null, undefined].includes(
                                    selectedOrder.membership_convenience_charge_discount
                                ) &&
                                ['0', '0.00', 0, null, undefined].includes(
                                    selectedOrder.membership_delivery_charge_discount
                                ) &&
                                ['0', '0.00', 0, null, undefined].includes(
                                    selectedOrder.membership_packaging_charge_discount
                                )
                            ) ? (
                                <>
                                    <RupeeSymbol size={'12px'} />
                                    {/* Discounted amount */}
                                    <span>
                                        {(
                                            parseFloat(
                                                selectedOrder.membership_convenience_charge_discount
                                                    ? selectedOrder.cart?.convenience_charge -
                                                          selectedOrder.membership_convenience_charge_discount
                                                    : selectedOrder.cart?.convenience_charge || 0
                                            ) +
                                            parseFloat(
                                                selectedOrder.membership_packaging_charge_discount
                                                    ? selectedOrder.cart?.packaging_charge -
                                                          selectedOrder.membership_packaging_charge_discount
                                                    : selectedOrder.cart?.packaging_charge || 0
                                            ) +
                                            selectedOrder.cart?.gst_amount
                                        ).toFixed(2)}
                                    </span>

                                    {/* Original amount with dash */}
                                    <span style={{ textDecoration: 'line-through', marginLeft: '8px' }}>
                                        {(
                                            (selectedOrder.cart?.gst_amount || 0) +
                                            (selectedOrder.cart?.packaging_charge || 0) +
                                            (selectedOrder.cart?.convenience_charge || 0)
                                        ).toFixed(2)}
                                    </span>
                                </>
                            ) : selectedOrder.cart ? (
                                <>
                                    <RupeeSymbol size={'12px'} />
                                    {(
                                        (selectedOrder.cart.gst_amount || 0) +
                                        (selectedOrder.cart.packaging_charge || 0) +
                                        (selectedOrder.cart.convenience_charge || 0)
                                    ).toFixed(2)}
                                </>
                            ) : (
                                <>
                                    <RupeeSymbol size={'12px'} />
                                    0.00
                                </>
                            )}
                        </td>
                    </tr>
                    {!props.isFromTableManagement ? (
                        <tr className='borderColorForTable'>
                            <td className='borderForFirstTd'>
                                Delivery Charge {checkFreeDeliveryOffer(selectedOrder)}
                            </td>
                            <td className='borderForSecondTd'>
                                {checkFreeDeliveryOffer(selectedOrder) ? (
                                    <>
                                        <span style={{ color: 'green' }}>Free </span>
                                        <span style={{ textDecoration: 'line-through', marginLeft: '5px' }}>
                                            <RupeeSymbol size={'12px'} />
                                            {selectedOrder.delivery_charge.toFixed(2)}
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <RupeeSymbol size={'12px'} />
                                        {selectedOrder.delivery_charge.toFixed(2)}{' '}
                                    </>
                                )}
                            </td>
                        </tr>
                    ) : null}

                    <tr className='borderColorForTable'>
                        <td className='borderForFirstTd'>
                            <b>Net Total</b>
                        </td>
                        <td className='borderForSecondTd'>
                            <b>
                                <RupeeSymbol size={'12px'} />
                                {selectedOrder?.net_total?.toFixed(2)}
                            </b>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default OrderTotalBill;
